<template>
<a-tooltip>
    <template slot="title"> 
        Accept
    </template>
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path class="first" d="M0.5 13C0.5 6.09653 6.09676 0.5 13 0.5C19.9037 0.5 25.4999 6.09651 25.4999 13C25.4999 19.9034 19.9039 25.4999 13 25.4999C6.09676 25.4999 0.5 19.9034 0.5 13Z" fill="white" stroke="#0ACF97"/>
<path class="second" d="M19.8007 9.78443L10.6145 18.9708L6.19792 14.5544C5.86632 14.2228 5.86632 13.6851 6.19791 13.3536C6.52949 13.022 7.06709 13.022 7.39869 13.3535L10.6146 16.5692L18.5999 8.58366C18.9315 8.25206 19.4691 8.25206 19.8007 8.58365C20.1323 8.91523 20.1323 9.45284 19.8007 9.78443Z" fill="#0ACF97"/>
</svg>
</a-tooltip>

</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
svg {
    cursor: pointer;
    path {
        transition: all 0.2s ease;
    }
    &:hover {
        path.first {
            fill: #0ACF97; 
        }
        path.second {
            fill: #ffffff;
        }
    }
}
</style>